import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_material_by_materialIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { material_id: number }): 
  Promise<{ result: { Id?: number, AllocationStrategyId?: number, AllocationStrategyWorkflowId?: string, ControllerTypeId?: number, Description?: string, GlobalMaterialId?: number, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean, KitTypeId?: number, LookupCode?: string, MaterialGroupId?: number, MinimumDatingSpan?: number, Name?: string, ProjectId?: number, ScanSerialOfAllPackageLevels?: boolean, Status?: { Id?: number, Name?: string }, MaterialGroup?: { Name?: string } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.material_id)) {
      missingRequiredInParams.push('\'material_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_material_by_materialId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      material_id: number    }) {
        if(isNil(inParams.material_id)) {
          return true; 
        }
      return false;
    }
}
